import { render, staticRenderFns } from "./ProductSheet.vue?vue&type=template&id=72ddb364&"
import script from "./ProductSheet.ts?vue&type=script&lang=ts&"
export * from "./ProductSheet.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports